import { IconType } from '@src/IconType';
import {
  type InvitedRecruiter,
  type Recruiter,
  getRecruitersWithInvited,
} from '@src/api/services/RecruiterService';
import { usePromise } from '../usePromise';
import { useTranslation } from 'react-i18next';

export const useRecruiter = (organizationId: string | null) => {
  const { t: tCommon, i18n } = useTranslation('common');

  const formatValidUntil = (invitedRecruiter: InvitedRecruiter): string => {
    const formattedDate = invitedRecruiter.expiresAt.toLocaleString(
      i18n.language,
      {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      },
    );
    return `${tCommon('validUntil')}: ${formattedDate}`;
  };

  const recruiterData = usePromise(
    async () =>
      organizationId
        ? getRecruitersWithInvited(organizationId)
        : ([] as Recruiter[]),
    { setLoadingStateOnRefresh: true },
    [organizationId],
  );

  const getIcon = (recruiter: Recruiter): IconType | undefined => {
    if (recruiter.accepted) {
      return undefined;
    }
    return IconType.Envelope;
  };

  return {
    formatValidUntil,
    ...recruiterData,
    getIcon,
  };
};
